/* LM V7 homepage: slider arrows + progress line on any row that scrolls sideways */
(function(){
  function init(root){
    (root||document).querySelectorAll('.lm7 .l7-bchips,.lm7 .l7-grid5,.lm7 .l7-kits,.lm7 .l7-proofs').forEach(function(row){
      if(row.dataset.lm7s)return;row.dataset.lm7s='1';
      var c=document.createElement('div');c.className='l7-sctl';
      c.innerHTML='<div class="l7-trk"><i></i></div><button type="button" aria-label="Previous">&#8249;</button><button type="button" aria-label="Next">&#8250;</button>';
      row.after(c);var bar=c.querySelector('i'),b=c.querySelectorAll('button');
      function step(){var k=row.firstElementChild;return k?k.getBoundingClientRect().width+12:240}
      b[0].onclick=function(){row.scrollBy({left:-step(),behavior:'smooth'})};
      b[1].onclick=function(){row.scrollBy({left:step(),behavior:'smooth'})};
      function upd(){var max=row.scrollWidth-row.clientWidth;c.hidden=max<20;if(max<20)return;
        var w=row.clientWidth/row.scrollWidth*100;bar.style.width=w+'%';bar.style.left=(row.scrollLeft/max*(100-w))+'%';
        b[0].disabled=row.scrollLeft<4;b[1].disabled=row.scrollLeft>max-4;}
      row.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);upd();
    });
  }
  function heroH(){var h=document.querySelector('.lm7 .l7-hero');if(!h)return;var top=h.getBoundingClientRect().top+window.scrollY;if(top<window.innerHeight*0.7)h.style.setProperty('--lm7-hero-h',(window.innerHeight-top)+'px')}
  var lw=window.innerWidth;window.addEventListener('resize',function(){if(window.innerWidth!==lw){lw=window.innerWidth;heroH()}});window.addEventListener('load',heroH);
  if(document.readyState!=='loading'){init();heroH()}else document.addEventListener('DOMContentLoaded',function(){init();heroH()});
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
